import React from 'react';
import styles from './EmptyViewer.module.scss';
import { Text } from '../../typography';
import Button from '../../Button';
import { useTranslation } from 'react-i18next';
import { keys } from '../../../utilities/translator/translation_keys';
import { robotPictures } from '../../../utilities';

export default function EmptyViewer({ file, onDetailsClick, onClose }) {
  const { t } = useTranslation();

  const downloadAllowed =
    !!file?.downloadAllowed ||
    file?.type === 'INVESTIGATION' ||
    file?.__typename === 'ObservationImage' ||
    file?.__typename === 'IncidentImage' ||
    !!file?.isCertification;

  return (
    <div className={styles.container}>
      <img
        className={styles.image}
        alt="Not Supported"
        src={robotPictures.read}
      />
      <Text size="lg" weight="bold" textAlign="center">
        {t(keys.files.EMPTY_VIEWER_TITLE)}
      </Text>
      <Text size="md" weight="semiBold" color="secondary" textAlign="center">
        {downloadAllowed
          ? t(keys.files.FILE_TYPE_MESSAGE)
          : t(keys.files.DOWNLOAD_DISABLED_MESSAGE)}
      </Text>
      {!downloadAllowed ? (
        <>
          <br />
          {!!onDetailsClick && (
            <Button
              className={styles.button}
              icon="info"
              value={t(keys.common.DETAILS)}
              variant="secondary"
              outlined
              onClick={() => {
                onDetailsClick();
                onClose();
              }}
            />
          )}
        </>
      ) : (
        <>
          <br />
          <Button
            className={styles.button}
            value={t(keys.action.DOWNLOAD)}
            icon="download"
            onClick={() => {
              onClose();
              const downloadFile = (url, name) => {
                fetch(url)
                  .then((response) => response.blob())
                  .then((blob) => {
                    const objectUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    const awsExtension = new URL(url).pathname
                      .split('/')
                      .pop()
                      ?.split('.')
                      .pop();
                    if (name?.split('.').length > 1) {
                      link.download = name;
                    } else {
                      link.download = name + '.' + awsExtension;
                    }
                    link.href = objectUrl;
                    link.click();
                    URL.revokeObjectURL(objectUrl);
                  })
                  .catch((error) => console.error(error));
              };
              downloadFile(
                file?.url ?? file?.imageUrl,
                file?.name ?? 'no-file-name-found',
              );
            }}
          />
        </>
      )}
    </div>
  );
}
